import React from 'react'

import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { setSelectedProvider, setModalProviderOpen } from 'Redux/purchases/actions'
import moment from 'moment'
import 'moment/locale/es'
import { HAS_CALENDAR } from 'Config/constants'
import Button from '@material-ui/core/Button'
import { ReactComponent as ProviderIcon } from 'Assets/Icons/Proveedor.svg'
import { NumberFormat } from 'Components/atoms'
import routes from 'Config/routes'

import {
  CardContainer,
  TextsContainer,
  Name,
  NextDeliveryDate,
  FormattedDate,
  useStyles,
  Price,
  TextAmount,
  RowAmount,
} from './styled'

const Card = ({ name, id, refProp, nextDeliveryDate, calendar, minAmount }) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const history = useHistory()
  const dispatch = useDispatch()

  const center = useSelector(state => state.auth.selectedCenter)
  const { showPrice } = center

  const onClickButton = e => {
    e.stopPropagation()
    history.push(`${routes.addProvider(id)}/category/all`)
  }

  const onClickProvider = () => {
    dispatch(setSelectedProvider({ name, id, nextDeliveryDate, calendar, orderMinimum: minAmount }))
    dispatch(setModalProviderOpen(true))
  }

  const formattedDate = moment(nextDeliveryDate).format('dddd, LL')

  return (
    <CardContainer ref={refProp} onClick={onClickProvider}>
      <TextsContainer>
        <Name>{name}</Name>
        {calendar === HAS_CALENDAR.YES && !nextDeliveryDate ? (
          <NextDeliveryDate>{t('noCalendar')}</NextDeliveryDate>
        ) : null}
        {nextDeliveryDate ? (
          <NextDeliveryDate>
            {t('nextDeliveryDate')}
            <FormattedDate>{formattedDate}</FormattedDate>
          </NextDeliveryDate>
        ) : null}
        {minAmount && showPrice && (
          <RowAmount>
            <TextAmount>{`${t('minAmount')}: `} </TextAmount>
            <Price>
              <NumberFormat value={minAmount} suffix='€' />
            </Price>
          </RowAmount>
        )}
      </TextsContainer>
      <Button endIcon={<ProviderIcon />} className={classes.addCartButton} onClick={onClickButton}>
        {t('seeProducts')}
      </Button>
    </CardContainer>
  )
}

Card.defaultProps = {
  name: '',
  id: '',
  refProp: () => {},
  nextDeliveryDate: '',
  calendar: '',
  minAmount: null,
}

Card.propTypes = {
  name: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  refProp: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  nextDeliveryDate: PropTypes.string,
  calendar: PropTypes.string,
  minAmount: PropTypes.number,
}
export default Card
